// TreatmentForm.jsx
import { useState } from "react"
import "../../css/DemoCode.css"

/**
 * Treatment Form is a group of data inputs usually shown when clicking on Node->Treatment. 
 * This form is contained within TreatmentDialog.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {string} target The name of the node targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function TreatmentForm({model, setModel, fullModel, target}) {
  const [pollutantIDs, setPollutantIDs]   = useState((Object.keys(fullModel.POLLUTANTS).length===0?[]:Object.keys(fullModel.POLLUTANTS)))

  // When there is a change to an input element, modify the model.
  const updateValue = (val, type) => {
    if(model && model.TREATMENT){
      setModel(prev => ({
        ...prev,
        TREATMENT:{
          ...prev.TREATMENT,
          [target]: {
            ...prev.TREATMENT[target],
            [type]: val
          }
        }
      }))
    }
  }

  if(model){
    return(
      <>
      {
        <>
          {(
            target && 
            target.length > 0 && 
            pollutantIDs.map((id)=>(
              <label className='editor-small' key={'Treatment'+target+id}>{id}
                <input  type = "text"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, id)}}
                        value={model.TREATMENT[target][id]}
                        id={'Treatment'+target+id}
                />
              </label>
            ))
          )}
        </>
      }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}